import { render, staticRenderFns } from "./import-case-merge.vue?vue&type=template&id=118f3a3a&scoped=true"
import script from "./import-case-merge.vue?vue&type=script&lang=ts"
export * from "./import-case-merge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118f3a3a",
  null
  
)

export default component.exports